import { createAsyncThunk } from '@reduxjs/toolkit'
import { SCREEN } from '../../../../../../common/selectCurrencyUnit/constant'
import { calculateDefaultUnit } from '../../../../../../common/selectCurrencyUnit/slice'
import { handleExport } from '../../../../../../helpers/export'
import FinancialAnalysisService from '../../../core/service'
import { mapAllVNDValue } from '../../../helper'

const screen = SCREEN.FINANCIAL_ANALYSIS

export const getNonBankLoanBookBreakdownThunk = createAsyncThunk(
  'financialAnalysis/NonBank/getBankLoanBookBreakdown',
  async (data, { rejectWithValue, dispatch }) => {
    const response = await FinancialAnalysisService.getLoanBookBreakdown(data)
    if (response.success) {
      const getValues = () => mapAllVNDValue(response.data)
      dispatch(calculateDefaultUnit({ screen, getValues }))
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const downloadNonBankLoanBookBreakdown = createAsyncThunk(
  'financialAnalysis/NonBank/downloadBankLoanBookBreakdown',
  async (data) => {
    const response = await FinancialAnalysisService.downloadLoanBookBreakdown(
      data,
    )
    handleExport(response.data, response.filename)
  },
)
